import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowRight,
  faBullseye,
  faClock,
  faChartLine,
} from '@fortawesome/free-solid-svg-icons';

import contiMascot from '../imagesHome/conti_cont_inexistent.png';

import './OnboardingIntro.css';

const OnboardingIntro = () => {
  const navigate = useNavigate();

  const handleStart = () => {
    navigate('/quiz-start');
  };

  const handleBackToLogin = () => {
    navigate('/login');
  };

  return (
    <div className="onboarding-intro-page">

      <div className="onboarding-intro-card">

        <button
          type="button"
          className="onboarding-intro-back"
          onClick={handleBackToLogin}
        >
          Inapoi la conectare
        </button>

        <div className="onboarding-intro-mascot-wrapper">
          <img
            src={contiMascot}
            alt="Conti"
            className="onboarding-intro-mascot"
          />
        </div>

    <div className="onboarding-intro-content">

  <h1>
    Oops! inca nu ai cont pe ContaLearn
  </h1>

  <p className="onboarding-intro-description">
    Nu am gasit un cont asociat acestei adrese de email. Pentru a-ti crea unul, raspunde mai intai la cateva intrebari scurte. Asa iti putem personaliza experienta.
  </p>

  <div className="onboarding-intro-benefits">

    <div className="onboarding-intro-benefit">
      <FontAwesomeIcon
        icon={faBullseye}
        className="onboarding-intro-benefit-icon"
      />

      <div>
        <h3>Lectii potrivite obiectivelor tale</h3>
        <p>
          Ne spui ce vrei sa inveti, iar noi iti putem oferi
          o experienta mai relevanta.
        </p>
      </div>
    </div>

    <div className="onboarding-intro-benefit">
      <FontAwesomeIcon
        icon={faChartLine}
        className="onboarding-intro-benefit-icon"
      />

      <div>
        <h3>Pornesti de la nivelul potrivit</h3>
        <p>
          Cateva raspunsuri ne ajuta sa intelegem cat de
          familiarizat esti cu contabilitatea.
        </p>
      </div>
    </div>

    <div className="onboarding-intro-benefit">
      <FontAwesomeIcon
        icon={faClock}
        className="onboarding-intro-benefit-icon"
      />

      <div>
        <h3>Dureaza mai putin de un minut</h3>
        <p>
          Raspunzi la cateva intrebari, apoi continui cu
          crearea contului.
        </p>
      </div>
    </div>

  </div>

  <button
    type="button"
    className="onboarding-intro-start"
    onClick={handleStart}
  >
    Continua
    <FontAwesomeIcon icon={faArrowRight} />
  </button>

  <p className="onboarding-intro-note">
    Dupa aceste intrebari vei putea alege cum doresti sa iti
    creezi contul.
  </p>

</div>

      </div>

    </div>
  );
};

export default OnboardingIntro;